import React, { useEffect, useState, useRef } from 'react';
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-phone-number-input/style.css'
//core imports
import Snackbar from "components/Snackbar/Snackbar.js";
import Button from "components/CustomButtons/Button.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import MaskReal from 'services/formateRS';
import DatePicker from "components/Datepicker/Datepicker";
//material imports
import AddAlert from "@material-ui/icons/AddAlert";
import Input from '@mui/material/Input';

function ModalDeliverySell(props) {
    console.log(props)
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const { storageId, storageUserType } = useAuth();
    const fileInputRef = useRef();
    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [paidValue, setPaidValue] = useState(0);
    const [paymentDate, setPaymentDate] = useState(new Date().withoutTime());
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState();
    const [deliveryman, setDeliveryman] = useState([]);
    const [deliverymanId, setDeliverymanId] = useState(0)

    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);

    useEffect(() => {
        loadDeliveryman();
    }, []);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.loadSell();
                        props.onHide();
                    }, 700);
                }
                break;
            default:
                break;
        }
    };

    const handleButtonClick = (e) => {
        e.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Dispara o clique no input
        } else {
            console.error("Ref para o Input não está configurada.");
        }
    };
    async function handleFileUpload(event) {
        setFile(event.target.files[0]);
        setFileName(event.target.files[0].name);
    };
    async function loadDeliveryman() {
        const response = await api.get(`/deliveryman/drop?type=${storageUserType}&id=${storageId}`)
        setDeliveryman(response.data);
        if (response.data.length > 0) {
            setDeliverymanId(response.data[0].id)
        };
    };
    const handleAddPayment = async (e) => {
        e.preventDefault();
        try {
            if (!file) {
                return alert("Selecione o comprovante")
            }
            console.log(file, deliverymanId)
            const formData = new FormData();
            formData.append('fileimage', file);
            formData.append('id', deliverymanId);
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            console.log(formData)
            const addPayment = await api.post(`/file/receipt/for/app/test/for?nf=${props.props[0].nf}`, formData, {
                headers: {
                    "Content-Type": `multipart/form-data`,
                }
            });
            console.log(addPayment)
            if (addPayment.status === 200) {
                setControlSnack(true);
            };
        } catch (error) {
            console.log(error)
        }

    };
    console.log(deliveryman)
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Entregar nf {props.props[0].nf}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddPayment}>
                <Modal.Body >
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridSellsman">
                            <Form.Label>Vendedor</Form.Label>
                            <Form.Control onChange={event => setDeliverymanId(event.target.value)} as="select" defaultValue="Choose...">
                                {deliveryman.map(deliveryman => (
                                    <option key={deliveryman.id} value={deliveryman.id}>{deliveryman.deliverymanname}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>DATA</Form.Label>
                            <div>
                                <Input
                                    type="file"
                                    id="contained-button-file"
                                    placement="top"
                                    inputRef={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileUpload}
                                />
                                <button onClick={handleButtonClick}>Carregar Arquivo</button>
                            </div>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Entregar
                        </Button>
                    </div>
                    <Snackbar
                        place="br"
                        color="success"
                        icon={AddAlert}
                        message="Venda entregue com sucesso"
                        open={br}
                        closeNotification={() => setBR(false)}
                        close
                    />
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalDeliverySell;